<template>
  <div>
    <second-header
      :ies="fast_ies" 
      :periods="current_ies ? available_periods : undefined"
    />
    <v-card class="mt-2 mx-1" tile flat>
      <stack 
        ref="stack"
        :column-min-width="350"
        :gutter-width="8"
        :gutter-height="8"
      >
        <stack-item>
          <gauge-chart 
            :value="current_period_ies ? current_period_ies.equality_index : 0"
            class="pa-3" 
            :ies="fast_ies"
            :period="current_period"
          />
        </stack-item>
        <stack-item>
          <axes-chart class="pa-3" :ies="current_ies"/>
        </stack-item>
        <stack-item>
          <historic-data
            class="pa-3"
            :periods_ies="available_periods"
            :ies="current_ies"
          />
        </stack-item>
        <stack-item>
          <resources :ies="current_ies" :period="current_period_ies"/>
        </stack-item>
        <stack-item>
          <inst-transv :ies="current_ies"/>
        </stack-item>
      </stack>
    </v-card>
    
    <methodology/>
    <v-skeleton-loader
      :loading="!current_ies"
      class="mx-auto"
      transition="scale-transition"
      type="table"
    >
     <mekko-chart :ies="current_ies" ref="mekko"/>
    </v-skeleton-loader>
  </div>
</template>


<script>

import Methodology from "../common/Methodology";
import AxesChart from "../data_viz/AxesChart";
import HistoricData from "../data_viz/HistoricData";
import SecondHeader from "../common/SecondHeader";
import Resources from "../common/Resources";
import GaugeChart from "../charts/GaugeChart";
import { Stack, StackItem } from 'vue-stack-grid';
import homeMixin from "../homeMixin";
import InstTransv from "../data_viz/InstTransv";
import homeHolderMixin from "../homeHolderMixin";
import MekkoChart from "../charts/MekkoChart";
import { mapState, } from "vuex";
import * as d3 from 'd3';
import router from '@/router'
import InterCard from "./InterCard";


export default {
  name: 'IesHolder',
  components: {
    Methodology,
    AxesChart,
    HistoricData,
    InstTransv,
    SecondHeader,
    Resources,
    GaugeChart,
    MekkoChart,
    Stack,
    StackItem,
    InterCard,
  },
  mixins: [homeMixin, homeHolderMixin],
  data(){
    return {
      transver_value: undefined,
      instit_value: undefined,
      ies_id: undefined,
    }
  },
  computed:{
    ...mapState({
      current_ies: state => state.current_ies,
      current_period: state => state.current_period,
      current_period_ies: state => state.current_period_ies,
    }),
    available_periods(){
      if (this.current_ies && this.valid_periods){
        const period_ies = this.current_ies.period_ies.filter(pi=>{
          return pi.is_official && pi.stage == 'final'
        })
        return period_ies.map(pi=>{
          pi.year = this.valid_periods.find(vp=> vp.id == pi.year).year
          return pi
        })
      }
      else{
        return []
      }
      /*return this.current_ies && this.valid_periods
        ? this.valid_periods.filter(vp=> 
          this.current_ies.period_ies.some(p_ies=>
            p_ies.is_official && p_ies.year == vp.id))
        : []*/

      
      /*
      return this.current_ies.period_ies.reduce((final, period)=>{
        if (period.stage == 'final' && period.is_official){
          try{
            var year = this.valid_periods.find(vp=>vp.id == period.year)
            year.details = period
            year.equality_index = period.equality_index
            final.push(year)            
          }
          catch(err){
          }
        }
        return final
      },[])*/
    },
    fast_ies(){
      if (this.show_charts) return this.current_ies
      var ies_id = this.ies_id || router.currentRoute.params.ies_id
      return this.ises ? this.ises.find(ies=>ies.id == ies_id) : undefined
    },
  },
  methods: {
    updateIes([ies_id, year=null]){
      //this.$store.dispatch('SHOW_CHARTS', false)
      if (!year)
        year = this.current_period
      this.goToTop()
      let params = { ies_id: ies_id, year: year.year}
      //console.log(params)
      console.log(year)
      this.$store.dispatch('GET_IES', params).then((response)=>{
        this.$refs.mekko.mekkoChart()
        //this.$store.dispatch('SHOW_CHARTS', true)
      })
    },
    goToTop(){
      this.$vuetify.goTo( 0, 
        {duration: 400, offset: 0, easing:'easeInOutCubic'})
    },
  },  
  created(){
    const extras = [
      {'state': 'tipos_pob', 'method':'FETCH_CAT_POBS'},
      {'state': 'current_ies', 'method':'GET_IES', 'eachPetition': true}
    ]
    this.getHomeCats(extras)
  },
  mounted(){
    this.goToTop()
  },
  beforeRouteUpdate (to, from, next) {
    this.ies_id = to.params.ies_id
    this.updateIes([to.params.ies_id])
    next()
  },
  watch:{
    current_period(after, before){
      //console.log(this.current_period_ies)
      if((before ? before.id != after.id : false) && 
          this.current_period_ies.year != after.id)
        this.updateIes([null, after])
      
    }    
  },
}
</script>

<style lang="scss" scoped>
</style>